module.exports = __webpack_public_path__ + "images/tesla_small7663e6b7bcf3aaa7f29bab33a314e099.png";